// extracted by mini-css-extract-plugin
module.exports = {"select-client-dialog":"select-client-dialog-6aec65fcc972e3f17183ddd9358e84ba"};